"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTextSummaryForClipboard = void 0;
require("../../core");
const getTextSummaryForClipboard = (wizardSummaryItems) => {
    return wizardSummaryItems.reduce((acc, curr) => {
        acc += `${curr.title}\n`;
        acc += curr.fields
            .filter((item) => !item.hidden)
            .map((item) => `${item.labelForClipboard || item.label} ${item.valueForClipboard}`)
            .join('\n');
        acc += '\n\n';
        return acc;
    }, '');
};
exports.getTextSummaryForClipboard = getTextSummaryForClipboard;
//# sourceMappingURL=getTextSummaryForClipboard.js.map